import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appTitle: "Primer Tracking"
  },
  mutations: {},
  actions: {
    userSignUp({ commit }, payload) {
      console.log(payload.email);
      commit("setLoading", true);
    }
  }
});
